import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { Spin } from "antd";

const PospDashBoard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [BaseUrl, setBaseURL] = useState("");
  const [loading, setloading] = useState("");
  const [DBData, setDBData] = useState("");

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
    fetchStates();
  }, []);

  const fetchStates = () => {
    setloading(true);
    axiosInPosp
      .get(`v1/posp/dashboard`)
      .then((res) => {
        console.log(res);
        const SData = res?.data;
        console.log(SData);
        setDBData(SData);
        setloading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        setloading(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  return (
    <>
      <Spin spinning={loading}>
        <div style={{ padding: "25px", background: "#F0F2F5" }}>
          <div className="p-dashboard row">
            <div className="dcard col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <div className="dcard-box">
                <div className="title">Clients</div>
                <div className="count">{DBData?.clients}</div>
              </div>
            </div>
            <div className="dcard col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <div className="dcard-box">
                <div className="title">Leads</div>
                <div className="count">{DBData?.quick_quotes}</div>
              </div>
            </div>
            <div className="dcard col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <div className="dcard-box">
                <div className="title">No of Policies</div>
                <div className="count">{DBData?.completed_quick_quotes}</div>
              </div>
            </div>
            <div className="dcard col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <div className="dcard-box">
                <div className="title">Revenue</div>
                <div className="count">0</div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default PospDashBoard;
